var CreateApplicationDetailsGtiaComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-gtia.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-gtia.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDetailsGtiaConstants } from "./create-application-details-gtia.constants";
let CreateApplicationDetailsGtiaComponent = class CreateApplicationDetailsGtiaComponent extends CreateApplicationViewBaseComponent {
    static { CreateApplicationDetailsGtiaComponent_1 = this; }
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    searchApplicationsService;
    // form controls
    detailsFormControlName = CreateApplicationDetailsGtiaConstants.DETAILS_FORM_CONTROL_NAME;
    descriptionFormControlName = CreateApplicationDetailsGtiaConstants.DESCRIPTION_FORM_CONTROL_NAME;
    referenceNumberControlName = CreateApplicationDetailsGtiaConstants.REFERENCE_NUMBER_CONTROL_NAME;
    fileNumberFormControlName = CreateApplicationDetailsGtiaConstants.FILE_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = CreateApplicationDetailsGtiaConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsGtiaConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    // labels
    addApplicationTypeLabel = CreateApplicationDetailsGtiaConstants.ADD_APPLICATION_TYPE_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = CreateApplicationDetailsGtiaConstants.APPLICATION_TYPE_LABEL;
    descriptionLabel = CreateApplicationDetailsGtiaConstants.DESCRIPTION_LABEL;
    fileNumberLabel = CreateApplicationDetailsGtiaConstants.FILE_NUMBER_LABEL;
    referenceNumberLabel = CreateApplicationDetailsGtiaConstants.REFERENCE_NUMBER_LABEL;
    validationMessages = CreateApplicationDetailsGtiaConstants.VALIDATION_MESSAGES;
    applicationTypeLookupName = SharedConstants.APPLICATION_TYPE_LOOKUP_NAME;
    detailsForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypes = [];
    showRefNumber = false;
    fullApplicationCheckRequired = false;
    applicationTypesControl;
    selectedApplicationDetailsGtiaSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.searchApplicationsService = searchApplicationsService;
    }
    static removeControlsByIndex(controls, index) {
        if (controls.controls.length > 1) {
            controls.removeAt(index);
        }
    }
    static setControlValue(formGroup, controlName, value, disableControl = false) {
        const formControl = formGroup.get(controlName);
        formControl.setValue(value);
        if (disableControl) {
            formControl.disable();
        }
    }
    ngOnInit() {
        this.initForm();
        this.getApplicationTypeLookups();
    }
    loadMetadata() {
        // step does not use metadata
    }
    getApplicationTypes() {
        return this.detailsForm.get(this.applicationTypesFormControlName);
    }
    onBtnRemoveApplicationTypeClicked(i) {
        const controls = this.getApplicationTypes();
        CreateApplicationDetailsGtiaComponent_1.removeControlsByIndex(controls, i);
    }
    onBtnAddApplicationTypeClicked() {
        this.applicationTypesControl = this.getApplicationTypes();
        const typeGroup = new FormGroup({
            type: new FormControl(null, [Validators.required])
        });
        this.applicationTypesControl.push(typeGroup);
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.detailsFormControlName);
    }
    getApplicationTypeLookups() {
        const filterString = `moduleId eq ${this.appControllerService.selectedModuleID} and (name eq '${this.applicationTypeLookupName}' and deleted eq false)`;
        const params = {
            $filter: filterString,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsGtiaConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === this.applicationTypeLookupName) {
                    this.applicationTypes.push(JSON.parse(item.content));
                }
            });
            this.sortApplicationTypesAlphabetically();
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationDetailsGtiaSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        // checks the application has application details set
        if (application.referenceNumber) {
            this.showRefNumber = true;
            this.detailsForm.get(this.referenceNumberControlName).enable();
            CreateApplicationDetailsGtiaComponent_1.setControlValue(this.detailsForm, this.referenceNumberControlName, application.referenceNumber, true);
        }
        else {
            this.showRefNumber = false;
        }
        if (application.description) {
            CreateApplicationDetailsGtiaComponent_1.setControlValue(this.detailsForm, this.descriptionFormControlName, application.description);
        }
        else {
            this.detailsForm.get(this.descriptionFormControlName).enable();
        }
        if (application.fileNumber) {
            CreateApplicationDetailsGtiaComponent_1.setControlValue(this.detailsForm, this.fileNumberFormControlName, application.fileNumber);
        }
        else {
            this.detailsForm.get(this.fileNumberFormControlName).enable();
        }
        if (application.applicationTypes && application.applicationTypes.length > 0) {
            const appTypes = application.applicationTypes;
            this.setTypes(appTypes);
        }
    }
    setTypes(appTypes) {
        const typesControl = this.getApplicationTypes();
        typesControl.clear();
        // sets application types from the application
        appTypes.forEach(applicationType => {
            let appType = null;
            this.applicationTypes.forEach(item => {
                if (item.value === applicationType.applicationType) {
                    appType = item;
                }
            });
            const typeGroup = new FormGroup({
                id: new FormControl(applicationType.id),
                applicationId: new FormControl(applicationType.applicationId),
                type: new FormControl(appType, Validators.min(1)),
                jobId: new FormControl(this.jobId)
            });
            typesControl.push(typeGroup);
        });
    }
    sortApplicationTypesAlphabetically() {
        if (this.applicationTypes.length > 0) {
            this.applicationTypes.sort((a, b) => (a.value?.localeCompare(b?.value)));
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsGtiaComponent = CreateApplicationDetailsGtiaComponent_1 = __decorate([
    Component({
        selector: "app-create-application-details-gtia",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsGtiaComponent);
export { CreateApplicationDetailsGtiaComponent };
